<script lang="ts" setup>
  import type { CSSProperties } from 'vue';
  import { onBeforeUnmount, onMounted, ref } from 'vue';
  import type { Space } from '../space.ts';
  import { Stack } from '../stack';

  withDefaults(
    defineProps<{
      space?: Space;
      overflow?: CSSProperties['overflowY'];
      justify?: CSSProperties['justifyContent'];
    }>(),
    {
      space: 'l',
      overflow: 'visible',
      justify: 'flex-start',
    },
  );

  const visibleHeight = ref<string>('100dvh');

  const followVisualViewport = () => {
    const viewport = window.visualViewport;
    if (viewport) visibleHeight.value = `${viewport.height}px`;
  };

  onMounted(() => {
    followVisualViewport();
    window.visualViewport?.addEventListener('resize', followVisualViewport);
  });

  onBeforeUnmount(() => window.visualViewport?.removeEventListener('resize', followVisualViewport));
</script>

<template>
  <div class="mobile-view-layout" :style="{ height: visibleHeight }">
    <slot name="header" />
    <Stack
      as="main"
      class="mobile-view-layout-main"
      :space="space"
      :style="{ overflowY: overflow, justifyContent: justify }"
    >
      <slot />
    </Stack>
    <footer v-if="$slots.footer" class="mobile-view-layout-footer">
      <slot name="footer" />
    </footer>
  </div>
</template>

<style scoped>
  .mobile-view-layout {
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .mobile-view-layout-main {
    align-items: center;
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    padding: var(--view-padding, 1rem var(--view-gutter));
  }

  .mobile-view-layout-footer {
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    gap: 0.75rem;
    justify-content: flex-start;
    min-height: 33dvh;
    padding: 0 var(--view-gutter) calc(1rem + env(safe-area-inset-bottom));
  }
</style>
